import React, { Component } from 'react';

import styles from './modal.module.scss';
import { strings } from '../../components/utils/translations'
import classnames from 'classnames';
import CloseIcon from '../../img/icons/closeIcon';
import DownloadFileIcon from '../../img/icons/download-files-icon.svg'
import PrimaryButton from '../Buttons/primaryButton';
import moment from 'moment';
import { CSVLink } from "react-csv"
import Loader from '../Loader'
import API from '../utils/API'
import { Utils } from '../utils/utils'
import { Tabs } from 'antd';

export default class DownloadActivityModal extends Component
{    
    constructor(props)
    {
        super(props)

        const { id, doorName, onClickClose } = props

        this.state =
        {
            doorId: id,
            doorName: doorName,
            onClickClose: onClickClose,
            
            isLoading: false,
            csvData: [],
            fileName: `activity-door_${id}_${doorName}`,
            filter:
            [
                'doors/get-events-and-actions',
                {
                    filter:
                    {
                        dateBegin: moment("2015-01-01T00:00:00").toISOString(),
                        dateEnd: moment().toISOString(),
                        limit: 999999
                    }
                },
                id
            ],
            headers:
            [
                {
                    key: ['date'],
                    title: strings('date')
                },
                {
                    key: ['type'],
                    title: strings('type')
                },
                {
                    key: ['name'],
                    title: strings('user')
                }
            ]
        }
    }

    render()
    {

        const { TabPane } = Tabs;

        return(
            <div className={styles.modal}>
                <div className={styles.modalTopBar}>
                    <h3 className={styles.title}>{ strings('downloadTheActivity') }</h3>
                    <CloseIcon className={styles.closeIcon} size="16" onClick={this.state.onClickClose} />
                </div>
                <div className="modalTabsContainer">                    
                    <div className={styles.contentBox}>
                        <div className={styles.box}>
                            <div className={styles.rightBlock}>
                                <img className={styles.icon} src={DownloadFileIcon} />
                            </div>
                            <div className={styles.leftBlock}>
                                <h4 className={styles.subtitle}>{ strings('downloadActivityDesc') }</h4>
                            </div>
                        </div>
                        <div className={ classnames([styles.downloadBtn, styles.activity]) }>
                            {
                                this.state.isLoading ?
                                <Loader
                                    spinner
                                    fullWidth
                                    centerHorizontal
                                    className={styles.spinner}
                                />
                                :
                                <PrimaryButton
                                    text={strings('downloadCsv')}
                                    style={{ width: '100%' }}
                                    onClick={() => this.generateCSV()}
                                />
                            }
                        </div>
                    </div>
                </div>
                
                <CSVLink
                    id={this.getLinkId()}
                    style={{display: "none"}}
                    filename={`${this.state.fileName}-${moment().local().format()}.csv`}
                    data={this.state.csvData}
                />
            </div>
        );
    }
    
    getAllActivity()
    {
        this.setState({ isLoading: true })
        
        let list =
        [
            this.state.headers.map(item => item.title)
        ]
        
        return new Promise(async (resolve, reject) =>
        {
            try
            {
                let res = await API.getInstance().GET(...this.state.filter)
                
                let dataArr = res
                
                if (res.eventsAndActions != null)
                {
                    dataArr = Utils.mergeActionsAndSensors([], res.eventsAndActions, true)
                }
                
                dataArr.forEach(item =>
                {
                    list.push(this.state.headers.map(headers =>
                    {
                        let val = item

                        headers.key.forEach(i =>
                        {
                            val = val[i]
                        })

                        return val
                    }))
                })

                this.setState({ isLoading: false })

                resolve(list)
            }
            catch(err)
            {
                console.log(err)
                this.setState({ isLoading: false })
                reject(err)
            }
        })
    }
    async generateCSV()
    {
        try
        {
            let list = await this.getAllActivity()
            
            if (list)
            {
                this.setState({ csvData: list }, () =>
                {
                    let link = document.getElementById(this.getLinkId())
                    link.click()
                })
            }
        }
        catch(err) { this.setState({ isLoading: false }) }
    }
    getLinkId()
    {
        return `csv-link-${this.state.fileName}`
    }
}